import {Step} from 'react-joyride';
import {tourText} from '../../texts/settingsGeneralText';
import {stepConfig} from './settingsGeneralStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getSettingsGeneralSteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'Settings');
